import React from "react";
import { Row, Col } from "react-bootstrap";

class Header extends React.Component {
  render() {
    const { Icon, Title, SubTitle, Buttons } = this.props;
    return (
      <Row className="mb-4">
        <Col xs={5}>
          <div className="d-flex align-items-center mb-2">
            <div className="c-shadow-wrapper">
              <div className="c-squircle c-background-white">{Icon}</div>
            </div>
            <h5 className="ms-4 d-inline d-xl-flex m-0">
              <strong>{Title}</strong>
            </h5>
          </div>
          <span className="text-muted">{SubTitle}</span>
        </Col>
        <Col xs={7} className="d-flex justify-content-end">
          {Buttons}
        </Col>
      </Row>
    );
  }
}

export default Header;
